<template>
  <div class="container" v-loading="loading">
    <template v-if="detail">
      <div class="base">
        <van-image round width="1.12rem" height="1.12rem" :src="$route.query.ImgUrl || avatar" />
        <div class="base-center">
          <div class="name">{{ $route.query.Name }}</div>
          <div class="room">房间号：{{ $route.query.Room }}</div>
        </div>
      </div>
      <div class="message">
        <div class="item">
          <span class="name">既往史：</span>
          <span class="value">{{ detail.Medicalhistory ? detail.Medicalhistory : '暂无数据' }}</span>
        </div>
        <div class="item">
          <span class="name">现病史：</span>
          <span class="value">{{ detail.Presentillness ? detail.Presentillness : '暂无数据' }}</span>
        </div>
        <div class="item">
          <span class="name">主诉：</span>
          <span class="value">{{ detail.Chiefcomplaint ? detail.Chiefcomplaint : '暂无数据' }}</span>
        </div>
      </div>
    </template>
    <div class="empty" v-if="!loading && !detail">暂无数据</div>
  </div>
</template>

<script>
import avatar from '@/assets/imgs/avatar.png'
export default {
  data() {
    return {
      loading: false,
      detail: '',
      avatar
    }
  },
  created() {
    this.loading = true
    this.$axios
      .post('/FamilySide/Filesupplementary?profileId=' + this.$route.query.Id)
      .then((res) => {
        this.loading = false
        this.detail = res.data.obj
      })
      .catch(() => {
        this.loading = false
      })
  }
}
</script>
<style scoped>
.container {
  padding: 15px;
  font-size: 16px;
}

.base {
  display: flex;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #cccc;
  background: #fff;
}

.base-center {
  margin-left: 12px;
}

.base-center .name {
  line-height: 1.5;
  color: #029fd1;
}

.base-center .room {
  line-height: 1.5;
}

.message {
  padding: 15px;
  background: #fff;
}

.message .item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
}

.message .name {
  flex-basis: 70px;
}

.message .value {
  flex: 1;
  color: #ccc;
}

.empty {
  margin-top: 200px;
  text-align: center;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/record/detail.vue